import React from 'react';
import classNames from 'classnames';

type StepDividerProps = {
  status: 'active' | 'disabled';
};
const StepDivider = ({status = 'disabled'}: StepDividerProps) => (
  <div
    className={classNames(
      `mx-2 h-[1px] w-2.5 opacity-30 ${
        status === 'active' ? 'bg-[#353d45]' : 'bg-[#353d45]'
      }`,
    )}
  />
);

export default StepDivider;
